(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/assets/javascripts/components/searchbar.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/assets/javascripts/components/searchbar.js');

'use strict';

const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Input = _svs$ui$reactForm.Input;
const links = svs.grassroots.links;
const _svs$ui$ReactListGrou = svs.ui.ReactListGroup,
  ListGroup = _svs$ui$ReactListGrou.ListGroup,
  ListItemLink = _svs$ui$ReactListGrou.ListItemLink;
const Link = svs.app.ReactRouter.Link;
const _svs$ui = svs.ui,
  Badge = _svs$ui.ReactBadge,
  ReactIcon = _svs$ui.ReactIcon;
const Item = _ref => {
  let longname = _ref.longname,
    subcategory = _ref.subcategory,
    supporters = _ref.supporters,
    points = _ref.points;
  return React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-12 col-md-7 align-left"
  }, React.createElement("div", null, longname, subcategory === '' ? React.createElement(Badge, {
    branding: "gray",
    className: "roundbadge padding-h margin-left"
  }, "Huvudf\xF6rening") : " - ".concat(subcategory))), React.createElement("div", {
    className: "col-xs-12 col-md-5 padding-xs-top padding-md-0"
  }, React.createElement("span", {
    className: "padding-xs-right padding-md-right-3"
  }, React.createElement(ReactIcon, {
    icon: "person"
  }), React.createElement("span", {
    className: "details-font"
  }, "".concat(supporters, " st"))), React.createElement("span", null, React.createElement(ReactIcon, {
    icon: "points"
  }), React.createElement("span", {
    className: "details-font"
  }, "".concat(points, " p")))));
};
const ListLinksMap = _ref2 => {
  let searchResult = _ref2.searchResult;
  return searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(_ref3 => {
    let longname = _ref3.longname,
      id = _ref3.id,
      shortname = _ref3.shortname,
      subcategory = _ref3.subcategory,
      supporters = _ref3.supporters,
      points = _ref3.points;
    return React.createElement(ListItemLink, {
      className: "search-item",
      key: id
    }, React.createElement(Link, {
      to: links.single(id, shortname)
    }, React.createElement(Item, {
      longname,
      subcategory,
      supporters,
      points
    })));
  });
};
const ListItemsMap = _ref4 => {
  let searchResult = _ref4.searchResult,
    onClick = _ref4.onClick;
  return searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(_ref5 => {
    let longname = _ref5.longname,
      id = _ref5.id,
      shortname = _ref5.shortname,
      subcategory = _ref5.subcategory,
      supporters = _ref5.supporters,
      points = _ref5.points;
    return React.createElement(ListItemLink, {
      className: "search-item",
      key: id
    }, React.createElement("a", {
      href: "#",
      onClick: () => onClick({
        longname,
        shortname,
        subcategory,
        id
      })
    }, React.createElement(Item, {
      longname,
      subcategory,
      supporters,
      points
    })));
  });
};
const Searchbar = _ref6 => {
  let onSubmit = _ref6.onSubmit,
    onChange = _ref6.onChange,
    onBlur = _ref6.onBlur,
    searchResult = _ref6.searchResult,
    searchterm = _ref6.searchterm,
    displayResults = _ref6.displayResults,
    onClick = _ref6.onClick;
  return React.createElement("div", {
    className: "searchbar-container margin-top-2"
  }, React.createElement(Form, {
    isVertical: true,
    onSubmit: onSubmit
  }, React.createElement(ControlGroup, null, React.createElement(Input, {
    autoComplete: "off",
    className: "searchbar-input",
    id: "searchbar",
    label: "S\xF6k p\xE5 f\xF6reningens namn, idrott, ort eller l\xE4n. Du kan \xE4ven kombinera s\xF6kkriterierna.",
    onBlur: onBlur,
    onChange: onChange,
    placeholder: "S\xF6k",
    size: "large",
    type: "text",
    value: searchterm
  })), displayResults && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 0 && React.createElement(ListGroup, {
    className: "search-suggestions form-vertical"
  }, !onClick && React.createElement(ListLinksMap, {
    searchResult
  }), onClick && React.createElement(ListItemsMap, {
    searchResult,
    onClick
  }))));
};
svs.grassroots.components.Searchbar = Searchbar;

 })(window);